import { render, staticRenderFns } from "./singleChoice.vue?vue&type=template&id=5b99cbd1&scoped=true"
import script from "./singleChoice.vue?vue&type=script&lang=ts"
export * from "./singleChoice.vue?vue&type=script&lang=ts"
import style0 from "./singleChoice.vue?vue&type=style&index=0&id=5b99cbd1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b99cbd1",
  null
  
)

export default component.exports